var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedLineAndRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 45,
    viewBox: "0 0 40 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: 79.1631,
    width: 128.89,
    height: 16.3071,
    rx: 8.15354,
    transform: "rotate(-39.6265 -70 79.1631)",
    fill: "#F9A7A7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 32.4453,
    width: 16.3781,
    height: 16.3071,
    rx: 8.15354,
    transform: "rotate(-39.6265 20 32.4453)",
    fill: "#F9A7A7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLineAndRectangle);
export default __webpack_public_path__ + "static/media/red-line-and-rectangle.3f803d9f3032578b473a284bfdc7915a.svg";
export { ForwardRef as ReactComponent };